/* eslint-disable max-len */
/* eslint-disable max-classes-per-file */
/* eslint-disable camelcase */
/* eslint-disable no-else-return */
/* eslint-disable no-inline-comments */
/* eslint func-names: ["error", "as-needed"] */
import React from 'react';
// import PropTypes from 'prop-types';
import { PivotData, PivotData_for_Destatis } from './utilities';
import Destatis from './utilities_for_Destatis';
import '../utils/arrayUtils';
import Tree from './Tree_utils';
import { ERROR_LOG } from './config';
import JsonHelper from '../utils/statisticsUtils';
// import ReactDOMServer from 'react-dom/server';

/* Placeholder that is inserted in empty enumerations of Auspraegungen,
 * in order to allow the Destatis Renderer 2 to build a hierarch
 */
const SENTINEL_AUSPRAEGUNG = Object.freeze({ code: 'NONE', inhalt: '...' }); // Vorschau Inhalt

const DISPLAY = Object.freeze({
  FS: 'FS', // Fachschlüssel
  KS: 'KS', // Klassifikationsschlüssel
  KN: 'KN', // Klarname
  FSKN: 'FSKN', // Fachschlüssel und Klarname
  FSKS: 'FSKS', // Fachschlüssel und Klassifikationsschlüssel
  KSKN: 'KSKN', // Klassifikationsschlüssel und Klarname
});

// eslint-disable-next-line camelcase
let some_number = 100; // quickhack: count number of preview table redraws
let some_other_number = 1000; // quickhack: create unique id for every dyn. generated react element
const tableRenderer2_cache = {};

// helper function for setting row/col-span in pivotTableRenderer
const spanSize = function (arr, i, j) {
  let x;
  if (i !== 0) {
    let asc;
    let end;
    let noDraw = true;
    for (
      x = 0, end = j, asc = end >= 0; // reverse iteration order if end index is negative
      asc ? x <= end : x >= end;
      asc ? x += 1 : x -= 1
    ) {
      if (arr[i - 1][x] !== arr[i][x]) { // if there is a column x,
        // in which the current and the previous row have different values, then draw the column
        noDraw = false;
      }
    }
    if (noDraw) {
      return -1; // signal that the current (data-)column is not rendered on the given header row
    }
  }
  let len = 0;
  while (i + len < arr.length) {
    let asc1;
    let end1;
    let stop = false;
    for (
      x = 0, end1 = j, asc1 = end1 >= 0; // reverse iteration order if end index is negative
      asc1 ? x <= end1 : x >= end1;
      asc1 ? x += 1 : x -= 1
    ) {
      if (arr[i][x] !== arr[i + len][x]) { // if there is a column x, ...
        stop = true;
      }
    }
    if (stop) {
      break;
    }
    len += 1;
  }
  return len;
};

function redColorScaleGenerator(values) {
  const minM = Math.min.apply(Math, values);
  const maxM = Math.max.apply(Math, values);
  return (x) => {
    // eslint-disable-next-line no-magic-numbers
    const nonRed = 255 - Math.round((255 * (x - minM)) / (maxM - minM));
    return { backgroundColor: `rgb(255,${nonRed},${nonRed})` };
  };
}

function makeRenderer(opts = {}) {
  class TableRenderer extends React.PureComponent {
    render() {
      const pivotData = new PivotData(this.props);
      const colAttrs = pivotData.props.cols;
      const rowAttrs = pivotData.props.rows;
      const rowKeys = pivotData.getRowKeys();
      const colKeys = pivotData.getColKeys();
      const grandTotalAggregator = pivotData.getAggregator([], []);

      let valueCellColors = () => { };
      let rowTotalColors = () => { };
      let colTotalColors = () => { };
      if (opts.heatmapMode) {
        const { tableColorScaleGenerator } = this.props;
        const colorScaleGenerator = tableColorScaleGenerator;
        const rowTotalValues = colKeys.map((x) => pivotData.getAggregator([], x).value());
        rowTotalColors = colorScaleGenerator(rowTotalValues);
        const colTotalValues = rowKeys.map((x) => pivotData.getAggregator(x, []).value());
        colTotalColors = colorScaleGenerator(colTotalValues);

        if (opts.heatmapMode === 'full') {
          const allValues = [];
          rowKeys.map((r) => colKeys.map((c) => allValues.push(pivotData.getAggregator(r, c).value())));
          const colorScale = colorScaleGenerator(allValues);
          valueCellColors = (r, c, v) => colorScale(v);
        } else if (opts.heatmapMode === 'row') {
          const rowColorScales = {};
          rowKeys.map((r) => {
            const rowValues = colKeys.map((x) => pivotData.getAggregator(r, x).value());
            rowColorScales[r] = colorScaleGenerator(rowValues);
          });
          valueCellColors = (r, c, v) => rowColorScales[r](v);
        } else if (opts.heatmapMode === 'col') {
          const colColorScales = {};
          colKeys.map((c) => {
            const colValues = rowKeys.map((x) => pivotData.getAggregator(x, c).value());
            colColorScales[c] = colorScaleGenerator(colValues);
          });
          valueCellColors = (r, c, v) => colColorScales[c](v);
        }
      }

      const getClickHandler = this.props.tableOptions && this.props.tableOptions.clickCallback
        ? (value, rowValues, colValues) => {
          const filters = {};
          for (const i of Object.keys(colAttrs || {})) {
            const attr = colAttrs[i];
            if (colValues[i] !== null) {
              filters[attr] = colValues[i];
            }
          }
          for (const i of Object.keys(rowAttrs || {})) {
            const attr = rowAttrs[i];
            if (rowValues[i] !== null) {
              filters[attr] = rowValues[i];
            }
          }
          return (e) => this.props.tableOptions.clickCallback(
            e,
            value,
            filters,
            pivotData,
          );
        }
        : null;
      return (
        <table className="pvtTable">
          <thead>
            {colAttrs.map(function (c, j) {
              return (
                <tr key={`colAttr${j}`}>
                  {j === 0
                    && rowAttrs.length !== 0 && (
                      <th colSpan={rowAttrs.length} rowSpan={colAttrs.length} />
                    )}
                  <th className="pvtAxisLabel">{c}</th>
                  {colKeys.map(function (colKey, i) {
                    const x = spanSize(colKeys, i, j);
                    if (x === -1) {
                      return null;
                    }
                    return (
                      <th
                        className="pvtColLabel"
                        key={`colKey${i}`}
                        colSpan={x}
                        rowSpan={
                          j === colAttrs.length - 1 && rowAttrs.length !== 0
                            ? 2
                            : 1
                        }
                      >
                        {colKey[j]}
                      </th>
                    );
                  })}

                  {j === 0 && (
                    <th
                      className="pvtTotalLabel"
                      rowSpan={
                        colAttrs.length + (rowAttrs.length === 0 ? 0 : 1)
                      }
                    >
                      Totals
                    </th>
                  )}
                </tr>
              );
            })}

            {rowAttrs.length !== 0 && (
              <tr>
                {rowAttrs.map(function (r, i) {
                  return (
                    <th className="pvtAxisLabel" key={`rowAttr${i}`}>
                      {r}
                    </th>
                  );
                })}
                <th className="pvtTotalLabel">
                  {colAttrs.length === 0 ? 'Totals' : null}
                </th>
              </tr>
            )}
          </thead>

          <tbody>
            {rowKeys.map(function (rowKey, i) {
              const totalAggregator = pivotData.getAggregator(rowKey, []);
              return (
                <tr key={`rowKeyRow${i}`}>
                  {rowKey.map(function (txt, j) {
                    const rowSpan_x = spanSize(rowKeys, i, j);
                    if (rowSpan_x === -1) {
                      return null;
                    }
                    return (
                      <th
                        key={`rowKeyLabel${i}-${j}`}
                        className="pvtRowLabel"
                        rowSpan={rowSpan_x}
                        colSpan={
                          j === rowAttrs.length - 1 && colAttrs.length !== 0
                            ? 2
                            : 1
                        }
                      >
                        {txt}
                      </th>
                    );
                  })}
                  {colKeys.map(function (colKey, j) {
                    const aggregator = pivotData.getAggregator(rowKey, colKey);
                    return (
                      <td
                        className="pvtVal"
                        key={`pvtVal${i}-${j}`}
                        onClick={
                          getClickHandler
                          && getClickHandler(aggregator.value(), rowKey, colKey)
                        }
                        style={valueCellColors(
                          rowKey,
                          colKey,
                          aggregator.value(),
                        )}
                      >
                        {aggregator.format(aggregator.value())}
                      </td>
                    );
                  })}
                  <td
                    className="pvtTotal"
                    onClick={
                      getClickHandler
                      && getClickHandler(totalAggregator.value(), rowKey, [null])
                    }
                    style={colTotalColors(totalAggregator.value())}
                  >
                    {totalAggregator.format(totalAggregator.value())}
                  </td>
                </tr>
              );
            })}

            <tr>
              <th
                className="pvtTotalLabel"
                colSpan={rowAttrs.length + (colAttrs.length === 0 ? 0 : 1)}
              >
                Totals
              </th>

              {colKeys.map(function (colKey, i) {
                const totalAggregator = pivotData.getAggregator([], colKey);
                return (
                  <td
                    className="pvtTotal"
                    key={`total${i}`}
                    onClick={
                      getClickHandler
                      && getClickHandler(totalAggregator.value(), [null], colKey)
                    }
                    style={rowTotalColors(totalAggregator.value())}
                  >
                    {totalAggregator.format(totalAggregator.value())}
                  </td>
                );
              })}

              <td
                onClick={
                  getClickHandler
                  && getClickHandler(grandTotalAggregator.value(), [null], [null])
                }
                className="pvtGrandTotal"
              >
                {grandTotalAggregator.format(grandTotalAggregator.value())}
              </td>
            </tr>
          </tbody>
        </table>
      );
    }
  }

  TableRenderer.defaultProps = PivotData.defaultProps;
  // TableRenderer.propTypes = PivotData.propTypes;
  TableRenderer.defaultProps.tableColorScaleGenerator = redColorScaleGenerator;
  TableRenderer.defaultProps.tableOptions = {};
  // TableRenderer.propTypes.tableColorScaleGenerator = PropTypes.func;
  // TableRenderer.propTypes.tableOptions = PropTypes.object;
  return TableRenderer;
}

class TSVExportRenderer extends React.PureComponent {
  render() {
    const pivotData = new PivotData(this.props);
    const rowKeys = pivotData.getRowKeys();
    const colKeys = pivotData.getColKeys();
    if (rowKeys.length === 0) {
      rowKeys.push([]);
    }
    if (colKeys.length === 0) {
      colKeys.push([]);
    }

    const headerRow = pivotData.props.rows.map((r) => r);
    if (colKeys.length === 1 && colKeys[0].length === 0) {
      headerRow.push(this.props.aggregatorName);
    } else {
      colKeys.map((c) => headerRow.push(c.join('-')));
    }

    const result = rowKeys.map((r) => {
      const row = r.map((x) => x);
      colKeys.map((c) => {
        const v = pivotData.getAggregator(r, c).value();
        row.push(v || '');
      });
      return row;
    });

    result.unshift(headerRow);

    return (
      <textarea
        value={result.map((r) => r.join('\t')).join('\n')}
        style={{ width: window.innerWidth / 2, height: window.innerHeight / 2 }}
        readOnly={true}
      />
    );
  }
}

TSVExportRenderer.defaultProps = PivotData.defaultProps;
// TSVExportRenderer.propTypes = PivotData.propTypes;

function makeDestatisRenderer(opts = {}) {
  class DestatisTableRenderer extends React.PureComponent {
    render() {
      if (ERROR_LOG) { console.log('makeDestatisRenderer::render called.'); }
      // this.props.rows :: [String]
      // this.props.cols :: [String]
      // TODO: unbundle data from row selection

      // send the row/column configuration to the server
      // and try to obtain the closest match in
      // prepared tables that we can download

      // then adjust the row/column selection:
      // a) highlight unselected data-columns that were delivered
      // b) grey-out any data-columns that was not delivered in the result
      // c) add icons which realization was chosen for a data-column (e.g. Zwischentitel)

      // convert a dictionary to a map
      // TODO: clean this mess of 2 mixed objects in objects
      const canhaz_merkmale_nullable = () => this.props.merkmale;
      const auspraegungen_map = {};
      const macodeMap = Destatis.build_macodeMap(canhaz_merkmale_nullable(), auspraegungen_map);

      /**
       * @param {string} macode [Merkmal.code].[Auspraegung.code] e.g. "[GES].[GESM]"
       * @return {string} the label of Auspraegung
       */
      const lift_code_to_auspraegung = (macode) => {
        const a = macodeMap[macode];
        if (a) { return a; }

        // prettyprint column title for server-calculated totals
        if (macode.endsWith('[%TOTAL%]')) { // TODO: map column name on proxy, maybe
          // try to split off mcode
          const mcode = (macode.split('.', 1) || [''])[0];
          const m = macodeMap[mcode];
          const label_insgesamt = m ? `${m.inhalt} insgesamt` : 'Insgesamt'; // TODO: move string interpolation to central position
          return { inhalt: label_insgesamt };
        }

        // prettyprint timeslice auspraegung for wintersemester
        if (macode.endsWith('10P6M]')) { // TODO: use algorithm instead of heustistic to match semesters e.g. [2017-10P6M] -> "WS 2017/18"
          const ws_rx = /\[([0-9]{4})-10P6M\]/;
          const mtch = macode.match(ws_rx); // TODO: handle match failure
          const yynext = (parseInt(mtch[1], 10) + 1) % 100;
          const yy00next = (yynext < 10 ? '0' : '') + yynext;
          const ws_inhalt = `WS ${mtch[1]}/${yy00next}`;
          return { inhalt: ws_inhalt };
        }
        if (ERROR_LOG) { console.warn(`failed to lift macode '${macode}' to Auspraegung`); }
        return macode;
      };

      const lift_code_to_merkmal = (mcode) => { return macodeMap[mcode]; };

      const bracketed_code_from_merkmal = (m) => m && Destatis.bracketize_mcode(m.code);

      // replace cols and rows with keys used by JSON-API
      // concat titles and rows for the purpose of building the table
      const colsMerkmale = (this.props.cols || []).map(Destatis.bracketize_mcode).map(lift_code_to_merkmal); // this.props.colsMerkmale || []
      const rowsMerkmale = (this.props.titles || []).concat(this.props.rows || []).map(Destatis.bracketize_mcode).map(lift_code_to_merkmal); // (this.props.titlesMerkmale||[]).concat(this.props.rowsMerkmale||[])
      const valsMerkmale = (this.props.vals || []).map(Destatis.bracketize_mcode).map(lift_code_to_merkmal); // this.props.valsMerkmale ||[]
      const titlesMerkmale = (this.props.titles || []).map(Destatis.bracketize_mcode).map(lift_code_to_merkmal); // this.props.titlesMerkmale || []

      const preparedProps = {
        // snwt: could also convert code to bracketed_code
        cols: (this.props.cols || []).map((c) => `[${c}]`), // this.props.colsMerkmale && this.props.colsMerkmale.map(bracketed_code_from_merkmal) || []
        rows: rowsMerkmale.map(bracketed_code_from_merkmal),
        vals: valsMerkmale.map(bracketed_code_from_merkmal),
        titles: titlesMerkmale.map(bracketed_code_from_merkmal), // TODO: remove titles
        colsMerkmale: colsMerkmale,
        rowsMerkmale: rowsMerkmale,
        valsMerkmale: valsMerkmale,
        titlesMerkmale: titlesMerkmale,
      };
      const pivotData_inputProps = Object.assign({}, this.props, preparedProps);
      if (ERROR_LOG) {
        console.log('pivotData_inputProps:', pivotData_inputProps); // ought to be e.g. "[GEN]"}

        // *Attrs is a list of Merkmal-codes (mcode)
        // *Keys is a list of lists of Merkmal-codes+Auspraegung.codes (macodes)
        // where xAttr[i] is a string-prefix of xKey[i][j] forall j

        const pivotData = new PivotData_for_Destatis(pivotData_inputProps); // this.props
        const colAttrs = pivotData.props.cols; // will contain array of "[Merkmal.code]"
        const rowAttrs = pivotData.props.rows; // will contain array of "[Merkmal.code]
        const rowKeys = pivotData.getRowKeys(); // will contain array of "[Merkmale.code].[Auspraegung.code]"
        const colKeys = pivotData.getColKeys(); // will contain array of "[Merkmale.code].[Auspraegung.code]"
        const grandTotalAggregator = pivotData.getAggregator([], []);

        // rowAttrs and rowKeys have a prefix of this length that are titles
        const title_length = (this.props.titlesMerkmale || []).length;
        if (ERROR_LOG) {
          console.log('colKeys: ', colKeys);
          console.log('colAttrs:', colAttrs);
        }

        let valueCellColors = () => { };
        let rowTotalColors = () => { };
        let colTotalColors = () => { };
        if (opts.heatmapMode) {
          const colorScaleGenerator = this.props.tableColorScaleGenerator;
          const rowTotalValues = colKeys.map((x) => pivotData.getAggregator([], x).value());
          rowTotalColors = colorScaleGenerator(rowTotalValues);
          const colTotalValues = rowKeys.map((x) => pivotData.getAggregator(x, []).value());
          colTotalColors = colorScaleGenerator(colTotalValues);

          if (opts.heatmapMode === 'full') {
            const allValues = [];
            rowKeys.map((r) => colKeys.map((c) => allValues.push(pivotData.getAggregator(r, c).value())));
            const colorScale = colorScaleGenerator(allValues);
            valueCellColors = (r, c, v) => colorScale(v);
          } else if (opts.heatmapMode === 'row') {
            const rowColorScales = {};
            rowKeys.map((r) => {
              const rowValues = colKeys.map((x) => pivotData.getAggregator(r, x).value());
              rowColorScales[r] = colorScaleGenerator(rowValues);
            });
            valueCellColors = (r, c, v) => rowColorScales[r](v);
          } else if (opts.heatmapMode === 'col') {
            const colColorScales = {};
            colKeys.map((c) => {
              const colValues = rowKeys.map((x) => pivotData.getAggregator(x, c).value());
              colColorScales[c] = colorScaleGenerator(colValues);
            });
            valueCellColors = (r, c, v) => colColorScales[c](v);
          }
        }

        const getClickHandler =
          this.props.tableOptions && this.props.tableOptions.clickCallback
            ? (value, rowValues, colValues) => {
              const filters = {};
              for (const i of Object.keys(colAttrs || {})) {
                const attr = colAttrs[i];
                if (colValues[i] !== null) {
                  filters[attr] = colValues[i];
                }
              }
              for (const i of Object.keys(rowAttrs || {})) {
                const attr = rowAttrs[i];
                if (rowValues[i] !== null) {
                  filters[attr] = rowValues[i];
                }
              }
              return (e) => this.props.tableOptions.clickCallback(
                e,
                value,
                filters,
                pivotData,
              );
            }
            : null;

        const overall_colspan = colKeys.length + rowKeys.length; // FIXME: colspan calucation

        // TODO: bring in static renderings here
        return (
          <table className="pvtTable">
            <thead>
              {// does render table title from Merkmale
                this.props.valsMerkmale && this.props.valsMerkmale.map((m, v_i) => {
                  const val_label = Destatis.prettyprint_merkmal(m);
                  return (
                    <tr key={`valAttr${v_i}`}>
                      <th
                        className="pvtAxisLabel"
                        colSpan={overall_colspan}
                      >
                        {val_label}
                      </th>
                    </tr>
                  );
                })
              }
              {// does render column headers
                colAttrs.map(function (mcode, j) { // *Attrs contains the headers, *Keys contains the values
                  const m = lift_code_to_merkmal(mcode);
                  const kopfzeile_label = Destatis.prettyprint_merkmal(m);
                  return (
                    <tr key={`colAttr${j}`}>
                      {j === 0
                        && rowAttrs.length !== 0 && ( /* subheadings: skip rows used as titles */
                          <th colSpan={rowAttrs.length - title_length} rowSpan={colAttrs.length} />
                        )}
                      <th className="pvtAxisLabel">{kopfzeile_label}</th>{/* render the part above the Vorspalte */}
                      {// does render the part above the data part of the table
                        colKeys.map(function (colKey, i) {
                          const colSpan_x = spanSize(colKeys, i, j);
                          if (colSpan_x === -1) {
                            return null; // acts as a filter, skipping those columns headers not rendered in the current row
                          }
                          const macode = colKey[j];
                          const colKey_label = lift_code_to_auspraegung(macode).inhalt || macode;
                          return (
                            <th
                              className="pvtColLabel"
                              key={`colKey${i}`}
                              colSpan={colSpan_x}
                              rowSpan={
                                j === colAttrs.length - 1 && rowAttrs.length !== 0
                                  ? 2
                                  : 1
                              }
                            >
                              {colKey_label}
                            </th>
                          );
                        })
                      }
                      {/* snwt: self-calculated totals disabled
                    j === 0 && (
                    <th
                      className="pvtTotalLabel"
                      rowSpan={
                        colAttrs.length + (rowAttrs.length === 0 ? 0 : 1)
                      }
                    >
                      Totals
                    </th>
                  ) */}
                    </tr>
                  );
                })
              }

              {// does render row labels (in header) - TODO: <tr key=?> here?
                rowAttrs.length !== 0 && (
                  <tr>
                    {// does render vorspalten header
                      // TODO: insert ueberschriften into vorspalten header
                      rowAttrs.slice(title_length) // subheadings: skip vorspalten used as titles
                        .map(function (r, i) {
                          const mcode = r;
                          const m = lift_code_to_merkmal(mcode);
                          const vorspalte_label = Destatis.prettyprint_merkmal(m);
                          return (
                            <th className="pvtAxisLabel" key={`rowAttr${i}`}>
                              {vorspalte_label}
                            </th>
                          );
                        })
                    }
                    {/* snwt: self-calculated totals disabled
                <th className="pvtTotalLabel">
                  {colAttrs.length === 0 ? 'Totals' : null}
                </th>
                */}
                  </tr>
                )
              }
            </thead>

            <tbody>
              {(() => {
                // const title_length = (this.props.titlesMerkmale||[]).length; // titleAttrs.length;
                const title_cursor = Array(title_length).fill(null); // buffer for keeping track of changing titles as we iterate through the rows

                // does loop over all rows
                return rowKeys.map(function (rowKey, i) { // rowKeys contain the body
                  const totalAggregator = pivotData.getAggregator(rowKey, []);

                  // determine how much of the vorspalte has changed since the last iteration
                  // if titles_changed_from_offset > title_length then nothing needs to be changed
                  // may return -1
                  // (This is the most primitve ad-hoc way to determine if a subheading must be inserted. I'm sure you can do better :)
                  const titles_changed_from_offset = [title_cursor, rowKey.slice(0, title_length)].transpose().findIndex(([a, b]) => a !== b);
                  const ntitles_changed = titles_changed_from_offset < 0 ? title_length : title_length - titles_changed_from_offset;

                  const buf_subheadings = titles_changed_from_offset < 0 ? []
                    : Array.range(titles_changed_from_offset, title_length).map((off_j) => {
                      const macode = rowKey[off_j];
                      const rowKey_label = lift_code_to_auspraegung(macode).inhalt || macode;

                      // update title_cursor
                      title_cursor[off_j] = macode;

                      // insert headings that have changed
                      return (
                        <tr key={`rowKeySubheading${off_j}`}>
                          <th
                            key={`rowKeyLabel${i}-${off_j}`}
                            className="pvtRowSubheading"
                            colSpan={overall_colspan}
                          >
                            {rowKey_label}
                          </th>
                        </tr>
                      );
                    });

                  const render_row_as_subheading = false;
                  if (render_row_as_subheading) {
                    return ''; // TODO remove
                  } else {
                    return buf_subheadings.concat(
                      <tr key={`rowKeyRow${i}`}>
                        {// does loop over all columns in vorspalte
                          rowKey.slice(title_length) // subheadings: skip columns used as titles, by slicing them off
                            .map(function (macode, j0) { // rowKey is an Array<Macode> e.g. [ "[GES].[GESW]", "[SEMEST].[2016-10P6M]", ... ] (all values for current row)
                              // TODO: skip by off_j
                              const j = j0 + title_length; /* subheadings */

                              const rowKey_label = lift_code_to_auspraegung(macode).inhalt || macode;
                              // TODO snwt: exempt certain vorspalten-items if they render as zwischen / untertitel
                              const x = spanSize(rowKeys, i, j); // subheadings: skip titles in span calculation
                              if (x === -1) {
                                return null;
                              }
                              return (
                                <th
                                  key={`rowKeyLabel${i}-${j}`}
                                  className="pvtRowLabel"
                                  rowSpan={x /*+ntitles_changed */} // subheadings: stretch down to compensate over skipped titles
                                  colSpan={
                                    j === (rowAttrs.length) - 1 && colAttrs.length !== 0
                                      ? 2
                                      : (1 /*+(title_length>0?1:0) */) /* subheadings: give extra width to vorspalte when skipping titles */
                                  }
                                >
                                  {rowKey_label}
                                </th>
                              );
                            })
                        }
                        {colKeys.map(function (colKey, j) { /* render table values */
                          const aggregator = pivotData.getAggregator(rowKey, colKey);
                          return (
                            <td
                              className="pvtVal"
                              key={`pvtVal${i}-${j}`}
                              onClick={
                                getClickHandler
                                && getClickHandler(aggregator.value(), rowKey, colKey)
                              }
                              style={valueCellColors(
                                rowKey,
                                colKey,
                                aggregator.value(),
                              )}
                            >
                              {aggregator.format(aggregator.value())}
                            </td>
                          );
                        })}
                        {/*
                    <td
                      className="pvtTotal"
                      onClick={
                        getClickHandler &&
                        getClickHandler(totalAggregator.value(), rowKey, [null])
                      }
                      style={colTotalColors(totalAggregator.value())}
                    >
                      {totalAggregator.format(totalAggregator.value())}
                    </td>
                    */}
                      </tr>,
                    );
                  }
                });
              })() /* execute the lambda */}
              {/* snwt: self-calculated totals disabled
            <tr>
              <th
                className="pvtTotalLabel"
                colSpan={rowAttrs.length + (colAttrs.length === 0 ? 0 : 1)}
              >
                Totals
              </th>

              {colKeys.map(function(colKey, i) {
                const totalAggregator = pivotData.getAggregator([], colKey);
                return (
                  <td
                    className="pvtTotal"
                    key={`total${i}`}
                    onClick={
                      getClickHandler &&
                      getClickHandler(totalAggregator.value(), [null], colKey)
                    }
                    style={rowTotalColors(totalAggregator.value())}
                  >
                    {totalAggregator.format(totalAggregator.value())}
                  </td>
                );
              })}

              <td
                onClick={
                  getClickHandler &&
                  getClickHandler(grandTotalAggregator.value(), [null], [null])
                }
                className="pvtGrandTotal"
              >
                {grandTotalAggregator.format(grandTotalAggregator.value())}
              </td>
            </tr>
          */}
            </tbody>
          </table>
        );
      }
    }
  }

  DestatisTableRenderer.defaultProps = PivotData.defaultProps;
  // DestatisTableRenderer.propTypes = PivotData.propTypes;
  DestatisTableRenderer.defaultProps.tableColorScaleGenerator = redColorScaleGenerator;
  DestatisTableRenderer.defaultProps.tableOptions = {};
  // DestatisTableRenderer.propTypes.tableColorScaleGenerator = PropTypes.func;
  // DestatisTableRenderer.propTypes.tableOptions = PropTypes.object;
  return DestatisTableRenderer;
}

// 3rd generation

function add(x, y) { return x + y; }
function mul(x, y) { return x * y; }
function max(x, y) { return Math.max(x, y); }

/** Apply side effect of `f` to all nodes in a tree that recurses over `.children`
 * @param {T[]} tree_ary the tree
 * @param {function} f the function run for its side-effects on nodes (e.g. f = (n) => { n.is_subheading = true; } )
 * @return {T[]} the tree_ary with side-effects applied
 */
function mark_tree_nodes(tree_ary, f) {
  if (!tree_ary || tree_ary.length === 0) { return tree_ary; }
  if (!(tree_ary instanceof Array)) { return mark_tree_nodes([tree_ary], f); }

  tree_ary.forEach((obj) => {
    f(obj);
    // special case for handling recursion
    mark_tree_nodes(obj.children, f);
  });
  return tree_ary;
}

/** Replace all empty child nodes in tree A with `tree_b_ary`
 * @param {T} tree_a_ary an array of tree nodes, in which .children contains the children
 * @param {T} tree_b_ary an array of tree nodes, in which .children contains the children
 * @return {T} composed array of tree nodes
 */
function concat_tree(tree_a_ary, tree_b_ary) {
  if (tree_a_ary === null) { return tree_b_ary; }
  if (tree_a_ary.length === 0) { return tree_b_ary; }
  if (!(tree_a_ary instanceof Array)) { return concat_tree([tree_a_ary], tree_b_ary); }
  if (!(tree_b_ary instanceof Array)) { return concat_tree(tree_a_ary, [tree_b_ary]); }

  return tree_a_ary.map((obj) => {
    const new_obj = Object.assign({}, obj); // assume shallow attributes
    // special case for handling recursion: overwrite shallow copy
    new_obj.children = concat_tree(obj.children, tree_b_ary);
    return new_obj;
  });
}

/*
function concat_tree_fast(tree_a_ary, tree_b_ary) { // same as above without .map
  if (tree_a_ary === null) { return tree_b_ary; }
  if (tree_a_ary.length === 0) { return tree_b_ary; }
  if (!(tree_a_ary instanceof Array)) { return concat_tree([tree_a_ary], tree_b_ary); }
  if (!(tree_b_ary instanceof Array)) { return concat_tree(tree_a_ary, [tree_b_ary]); }
  if (tree_b_ary.length === 0) { return tree_a_ary; }

  const result = [];
  for (let i = 0; i < tree_a_ary.length; i++) {
    const obj = tree_a_ary[i];
    const new_obj = Object.assign({}, obj); // assume shallow attributes
    // special case for handling recursion: overwrite shallow copy
    new_obj.children = concat_tree(obj.children, tree_b_ary);
    result.push(new_obj);
  }
  return result;
}

function test_concat_tree() {
  const treeA = [{ code: 'A1', children: [{ code: 'A2', children: [] }] }];
  const treeB = [{ code: 'B10', children: [{ code: 'B20', children: [] }] }, { code: 'B30', children: [] }];
  const treeAA = concat_tree(treeA, treeA);
  const treeAB = concat_tree(treeA, treeB);
  const treeBA = concat_tree(treeB, treeA);
  if (ERROR_LOG) {
    console.log('treeAA: ', treeAA);
    console.log('treeAB', treeAB);
    console.log('treeBA', treeBA);
  }
}
*/

function sortFeaturesByKey(a, b) {
  const order = new Intl.Collator('de', { numeric: true }).compare(a.code, b.code);
  return order;
}

function sortFeaturesByShortDescription(a, b) {
  const order = new Intl.Collator('de', { numeric: true }).compare(a.inhalt, b.inhalt);
  return order;
}

function sortFeaturesByClassificationKey(a, b) {
  const order = new Intl.Collator('de', { numeric: true }).compare(a.classificationKey, b.classificationKey);
  return order;
}


function ruleFilterToAuspraegungen(filter, level, variable) {
  const tmp = [];

  filter.forEach((filter) => {  
    filter.inhalt = " ".repeat(2 * level) + filter.inhalt
    tmp.push(filter)
    if(filter.nextSelectionForTableRenderer && filter.variableName !== variable)
      tmp.push(...ruleFilterToAuspraegungen(filter.nextSelectionForTableRenderer, level +1, variable))//.map((ns) => {return {name: ns.name, nextSelection: ns.childvalues, variableName: ns.variableName, inhalt: this.multiLanguage.returnInLanguage(obj, 'de')}})))
  })

  return tmp;
}

/** Transform the tree describing the Merkmal hierarchy (as given by react-sortable-tree, e.g. T = [{title: string, code:string, children:T[]}])
 * into a tree with Ausprägungen unfolded. Some levels may or may not want to display the Merkmal name.
 * By separating the tree-to-be-rendered from the colspan computation, tree rendering is made more maintainable.
 * @param {T[]} node_merkmal_ary a list of tree-nodes of type T
 * @param {function} lift_code_to_merkmal_f map a raw-mcode to a merkmal object as received by JSON api
 * @param {function<string,object>} get_auspraegungen_for_merkmal_code lookup list of auspraegungen
 * @param {boolean} is_subheading indicate whether this subtree contains subheadings (and only subheadings)
 * @returns {*} a tree of structure T' = [{label: string, macode_pair:Pair<string,string>, children:T'[]}]
 */
function pretransform_merkmal_tree(node_merkmal_ary, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, is_subheading, display_array = {}) {
  // *** performance optimized: eliminated .map and .filter (Jira 1542) ***
  // sanity-check & auto-wrap
  // console.log('DISPLAY#0', node_merkmal_ary);
  if (node_merkmal_ary === null || typeof node_merkmal_ary === 'undefined') { return []; } // may be undefined in the structure which sortable-tree returns
  if (!(node_merkmal_ary instanceof Array)) { return pretransform_merkmal_tree([node_merkmal_ary], lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, is_subheading); }
  // return early with empty transformed tree
  if (node_merkmal_ary.length === 0) { return []; }
  // map each node to a subtree
  const result = [];
  for (let k = 0; k < node_merkmal_ary.length; k += 1) {
    const node_merkmal = node_merkmal_ary[k];
    const m = lift_code_to_merkmal_f(node_merkmal.code);
    // TODO: consider timeslices and units too
    // function get_auspraegungen_for_merkmal(m) { return m.auspraegungen||[]; }
    // check if user wants to suppres display of Merkmal name, because it might overcrowd a table
    // (unfortunately Merkmal names in tables with Nebenordungen cannot be shown in the box on the northwest edge, due to ambiguity)
    // merkmal selection is a sort of filter and must therefore be attached to an input tree node
    // because if that merkmal appears in a subtree of multiple nebenordnungen, its show/hide state may differ
    const show_merkmal_name_here = node_merkmal.show_merkmal_name_in_header == null // eslint-disable-line no-eq-null, eqeqeq, (because it may be undefined)
      ? (!is_subheading) // default to true, unless this is a subheading, then don't show the merkmal
      : node_merkmal.show_merkmal_name_in_header;
    let auspraegungen_for_merkmal = [...get_auspraegungen_for_merkmal_code(node_merkmal.code)]; // address via json structure
    if(Array.isArray(node_merkmal.filter?.[0])) auspraegungen_for_merkmal = ruleFilterToAuspraegungen(node_merkmal.filter[node_merkmal.filter.length - 1], 0, node_merkmal.code)
    if (node_merkmal.labelStructure.sortCriterion === 'KEY') {
      auspraegungen_for_merkmal.sort(sortFeaturesByKey);
    } else if (node_merkmal.labelStructure.sortCriterion === 'DESCRIPTION') { // Enum KTX ist das gleiche
      auspraegungen_for_merkmal.sort(sortFeaturesByShortDescription);
    } else if (node_merkmal.labelStructure.sortCriterion === 'CLASSIFICATION_KEY') { // was CATEGORY = classification key
      auspraegungen_for_merkmal.sort(sortFeaturesByClassificationKey);
    }
    // console.log('SORTDIR', node_merkmal.labelStructure.sortDirection);
    if (node_merkmal.labelStructure.sortDirection === 'DESC') {
      auspraegungen_for_merkmal.reverse();
    }
    let auspraegungen_filter = node_merkmal.filter || 'default'; // `default` means to show all (no filter); `[]` means to shown none; otherwise a list of raw-acodes / values
    
    if(Array.isArray(node_merkmal.filter?.[0])) {
      auspraegungen_filter = [...node_merkmal.filter].reduce((accumulator, currentValue) => accumulator.concat(currentValue), []).map((a) => a.name)//node_merkmal.filter[node_merkmal.filter.length -1].map((i) => i.name)
    }
    const auspraegungen_shown = [];
    for (let i = 0; i < (auspraegungen_for_merkmal || [SENTINEL_AUSPRAEGUNG]).length; i += 1) {
      const a = (auspraegungen_for_merkmal || [SENTINEL_AUSPRAEGUNG])[i];
      if (auspraegungen_filter === 'default' || auspraegungen_filter.includes(a?.code) || auspraegungen_filter.includes(a?.name)) {
        // recurse; yes, the children of an Auspraegung are the Merkmale of the next level
        let a_children = [];
        if (node_merkmal.children) {
          a_children = pretransform_merkmal_tree(node_merkmal.children, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, is_subheading);
        }
        // TODO: replace Ausprägung or its code with a unit for Wertmerkmale
        const a_label = Destatis.prettyprint_auspraegung(m, a);
        // const display_selection = node_merkmal.uniqueId in display_array ? display_array[node_merkmal.uniqueId] : "";
        const display_selection = node_merkmal.display;
        let ret;
        // 448:
        switch (display_selection) { // switch auspraegung between showing name, code, or both
          case DISPLAY.FSKN:
            // console.log('DISPLAY#1', { label: a_label, addr: [node_merkmal.code, a.code], children: a_children });
            ret = {
              label: a.code,
              addr: [node_merkmal.code, a.code],
              children: [ // code before label
                { label: a_label, addr: [node_merkmal.code, a.code], children: a_children },
              ],
            };
            break;
          case DISPLAY.FSKS:
            ret = {
              label: a.code,
              addr: [node_merkmal.code, a.code],
              children: [ // code before label
                { label: a.classificationKey, addr: [node_merkmal.code, a.code], children: a_children },
              ],
            };
            break;
          case DISPLAY.KSKN:
            ret = {
              label: a.classificationKey,
              addr: [node_merkmal.code, a.code],
              children: [ // code before label
                { label: a_label, addr: [node_merkmal.code, a.code], children: a_children },
              ],
            };
            break;
          case DISPLAY.FS:
            ret = { label: a.code, addr: [node_merkmal.code, a.code], children: a_children };
            break;
          case DISPLAY.KS:
            ret = { label: a.classificationKey, addr: [node_merkmal.code, a.code], children: a_children };
            break;
          case DISPLAY.KN: // fallthrough
          default:
            ret = { label: a_label, addr: [node_merkmal.code, a.code], children: a_children };
        }
        // console.log('DISPLAY#21', ret, node_merkmal);
        auspraegungen_shown.push(ret);
      }
    }
    const m_label = Destatis.prettyprint_merkmal(m); // prettyprint merkmal
    const r = show_merkmal_name_here // if Merkmal is shown, wrap Auspraegungen in it
      ? [{
        label: m_label,
        children: auspraegungen_shown,
        addr: [node_merkmal.code],
        firstSumTotal: node_merkmal.firstSumTotal,
        lastSumTotal: node_merkmal.lastSumTotal,
        sumTogether: node_merkmal.sumTogether,
      }] // array to be unwrapped by flat
      : auspraegungen_shown;
    result.push(r);
  }
  return result.flat(); // `flat` must be provided by polyfill
}

/** Traverse the react-sortable-tree to find Merkmale that shall be rendered in the NWblock
 * @param {T[]} node_merkmal_ary a list of tree-nodes of type T
 * @param {function} lift_code_to_merkmal_f map a raw-mcode to a merkmal object as received by JSON api
 * @return {*} a list of Merkmale to be rendered in the NWblock
*/
function extract_nwblock_merkmale(node_merkmal_ary, lift_code_to_merkmal_f) {
  // sanity-check & auto-wrap
  if (node_merkmal_ary === null || typeof node_merkmal_ary === 'undefined') { return []; } // may be undefined in the structure which sortable-tree returns
  if (!(node_merkmal_ary instanceof Array)) { return extract_nwblock_merkmale([node_merkmal_ary], lift_code_to_merkmal_f); }
  // return early with empty transformed tree
  if (node_merkmal_ary.length === 0) { return []; }

  // collect from subtree; result is an array(1) of arrays(2); each array(1) representing a level of the tree
  const subtrees_ary = node_merkmal_ary.map((node_merkmal) => {
    const m = lift_code_to_merkmal_f(node_merkmal.code);

    const show_merkmal_name_here = node_merkmal.show_merkmal_name_in_nwblock == null // eslint-disable-line no-eq-null, eqeqeq, (because it may be undefined)
      ? false
      : node_merkmal.show_merkmal_name_in_nwblock;
    return [show_merkmal_name_here ? [m] : []].concat(extract_nwblock_merkmale(node_merkmal.children, lift_code_to_merkmal_f));
  });
  // merge the subtrees
  const strata = subtrees_ary.reduce(flat_zip, []);

  return strata;
}

/**
 * Join an array of arrays, like so:
 * flat_zip( [[1],[2],[3]], [[11],[22]] ) == [[1,11],[2,22],[3]]
 * @param  {Array<A[]>} as array
 * @param  {Array<A[]>} bs array
 * @return {Array<A[]>} as and bs joined on 2nd level, but not completely flat
*/
function flat_zip(as, bs) {
  const a = as && as.length ? as[0] : [];
  const b = bs && bs.length ? bs[0] : [];
  const hd = a.concat(b); // flat
  if (hd.length === 0) { return []; }// base case
  return [hd].concat(flat_zip(as.slice(1), bs.slice(1)));
}

/**
 * @param {T[]} pretransformed_tree_ary an array of tree nodes
 * // @param {int} global_span a span value used form .is_subheading nodes, which must span across the whole table, not just the heading
 * @return {int} a span value for the current level (side effect is monoization of sub-computations stored in attrubte .subtree_width)
 */
function synt_attr_colspan_on_pretransformed_tree(pretransformed_tree_ary) {
  if (!pretransformed_tree_ary) { return 0; }
  if (!(pretransformed_tree_ary instanceof Array)) { return synt_attr_colspan_on_pretransformed_tree([pretransformed_tree_ary]); } // sanity-check & auto-wrap

  // tree node may either be auspraegung or merkmal
  // merkmale with have an `addr` length of 1, auspraegung has length 2

  const aggregated_subtree_width = pretransformed_tree_ary.map((pre_t_node) => {
    if (pre_t_node.subtree_width) { return pre_t_node.subtree_width; } // we may use monoized values because the pretransformed_tree is constructed anew on render
    const subtree_width = synt_attr_colspan_on_pretransformed_tree(pre_t_node.children);
    pre_t_node.subtree_width = subtree_width; // monoize
    return subtree_width;
  }).reduce(add, 0); // sum over subtrees
  return Math.max(1, aggregated_subtree_width); // even tree-leaves without children span over at least 1 column
}

/**
 * @param {T} node_merkmal_ary a list of tree-nodes
 * @return {int} the length of the longest path from root to leaf
 */
function get_tree_depth(node_merkmal_ary) {
  return (node_merkmal_ary || []).map((node_merkmal) => 1 + get_tree_depth(node_merkmal.children)).reduce(max, 0);
}

let serial_key_number_for_react = 100;

/**
 * render rows into array (of rows) without enclosing <tr>s, so we may prefix them later
 * @param {node[]} pretransformed_tree_ary a (sub-)tree to render the header for
 * @param {int} subheading_span length of a whole column across the table for spanning a subheading destatis' style
 * @param {int} level_max is used to calculate the rowspan for the lowest-hanging tree-leaves
 * @param {int} level_i the level of the node_merkmal_list
 * @param {Array<html[]>} level_accu each level will eventually be wrapped in; outer array has 2x the entries as node_merkmal_list, containing flattended pairs of Merkmal and Auspraegung/Unit rows
 * @param {bool} flip exchange rowSpan and colSpan in the output (use when transposing the table afterwards)
 * @return {Array<html[]>} the level accu
 */
function render_header_row_impl(
  pretransformed_tree_ary, subheading_span, level_max, level_i = 0, level_accu = [], flip = false,
) {
  // console.log('RENDER#1', pretransformed_tree_ary, subheading_span, level_max);
  level_accu[level_i] = (level_accu[level_i] || []).concat(pretransformed_tree_ary.flatMap((pre_t_node) => {
    const rowspan = /* pre_t_node.is_subheading
                    ? subheading_span
                    :*/ (pre_t_node.children.length > 0
        ? 1 // ordinary row in header, spans over 1 row only
        : level_max - level_i); // last row in header subtree; must expand until last header level
    const colspan = synt_attr_colspan_on_pretransformed_tree(pre_t_node);

    // recursion; updates level_accu
    // console.log('RENDER#2', pretransformed_tree_ary, subheading_span, level_max);
    render_header_row_impl(pre_t_node.children, subheading_span, level_max, level_i + 1, level_accu, flip);
    return [(
      <th
        className={flip ? 'vorspalte' : 'kopfzeile'}
        rowSpan={flip ? colspan : rowspan}
        colSpan={flip ? rowspan : colspan}
        key={`pvtHeaderCell${level_i}-${serial_key_number_for_react++}`}>
        {pre_t_node.label || '-'}
      </th>
    )].concat(Array(colspan - 1).fill(null)); // pad with placeholder entries to allow stable transposition of matrix
  }));

  // pad with placeholder entries also for matrix elements below own depth limit to allow stable transposition of matrix
  if (!pretransformed_tree_ary || pretransformed_tree_ary.length === 0) {
    for (let i = level_i; i < level_max; i += 1) { level_accu[i] = (level_accu[i] || []).concat([null]); }
  }

  return level_accu;
}

function render_subheadings(title_merkmal_tree_ary, rendered_tree, overall_table_span, rendered_tree_depth, flip) {
  return render_subheadings_transposed(title_merkmal_tree_ary, rendered_tree.transpose(), overall_table_span, rendered_tree_depth, flip).transpose();
}

function render_subheadings_transposed(title_merkmal_tree_ary, rendered_tree_transposed, overall_table_span, rendered_tree_depth, flip) {
  if (!title_merkmal_tree_ary || title_merkmal_tree_ary.length === 0) { return rendered_tree_transposed; }
  // const tree_depth = rendered_tree.length;

  // console.log(`render_subheadings has title_merkmal_tree_ary:`,title_merkmal_tree_ary);

  const res1 = title_merkmal_tree_ary.map((title_node) => { // create a spanning cell for every heading entry
    const rowspan = overall_table_span;
    const colspan = 1; // never span more than 1

    const heading_col = [(
      <th
        className={flip ? 'untertitel-vertikal' : 'untertitel'}
        rowSpan={flip ? colspan : rowspan}
        colSpan={flip ? rowspan : colspan}
        key={`pvtHeaderSubheadingCell${0}-${serial_key_number_for_react++}`}>
        {title_node.label || '-x'}
      </th>
    )].concat(Array(Math.max(0, rendered_tree_depth - 1)).fill(null)); // pad with placeholder all the way down

    const subtree_headings_transposed = render_subheadings_transposed(title_node.children, rendered_tree_transposed, overall_table_span, rendered_tree_depth, flip);

    if (title_node.label !== '...') {
      return [heading_col].concat(subtree_headings_transposed);
    } else {
      return [heading_col];
    }
  }).flat();
  return res1;
}

// argument configuration for building a header (on top of table)
// title should not (but may) contain nebenordnungen
function render_header_row(title_merkmal_tree_ary, merkmal_tree_ary, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code) {
  const [subheading_yes, subheading_no] = [true, false];
  // TODO: move to join with vorspalte computation to get overall_table_span
  const pretransformed_title_ary = pretransform_merkmal_tree(title_merkmal_tree_ary, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_yes);
  const pretransformed_tree_ary = pretransform_merkmal_tree(merkmal_tree_ary, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_no);
  const overall_table_span = 8; // FIXME: insert here #rows_of_header_row + #rows_of_vorspalte
  return render_header_row_stage2(pretransformed_title_ary, pretransformed_tree_ary, overall_table_span);
}

function render_header_row_stage2(pretransformed_title_ary, pretransformed_tree_ary, overall_table_span) {
  const overall_tree_depth = get_tree_depth(pretransformed_tree_ary);
  const flip_no = false;
  const rendered_tree = render_header_row_impl(pretransformed_tree_ary, overall_table_span, overall_tree_depth, 0, [], flip_no).filter((e) => e.length > 0);

  const rendered_tree_depth = rendered_tree.length;
  const rendered_tree_with_subheadings = render_subheadings(pretransformed_title_ary, rendered_tree, overall_table_span, rendered_tree_depth, flip_no);

  return rendered_tree_with_subheadings;
}

// argument configuration for build a vorspalte (left of table)
function render_vorspalte(title_merkmal_tree_ary, merkmal_tree_ary, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code) {
  const [subheading_yes, subheading_no] = [true, false];
  // TODO: move to join with header_row computation to get overall_table_span
  const pretransformed_title_ary = pretransform_merkmal_tree(title_merkmal_tree_ary, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_yes);
  const pretransformed_tree_ary = pretransform_merkmal_tree(merkmal_tree_ary, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_no);
  const overall_table_span = 8; // FIXME: insert here #columns_of_vorspalte + #columns_of_header_row
  return render_vorspalte_stage2(pretransformed_title_ary, pretransformed_tree_ary, overall_table_span);
}

function render_vorspalte_stage2(pretransformed_title_ary, pretransformed_tree_ary, overall_table_span) {
  const overall_tree_depth = get_tree_depth(pretransformed_tree_ary);
  const flip_yes = true;
  const rendered_tree = render_header_row_impl(pretransformed_tree_ary, overall_table_span, overall_tree_depth, 0, [], flip_yes).filter((e) => e.length > 0);

  const rendered_tree_depth = rendered_tree.length;
  const rendered_tree_with_subheadings_transposed = render_subheadings_transposed(pretransformed_title_ary, rendered_tree.transpose(), overall_table_span, rendered_tree_depth, flip_yes);

  return rendered_tree_with_subheadings_transposed;
}

// build the block on top-left corner of a table
// TODO: consider rows/cols not rendering their Merkmal (and only showing Auspraegung)
// NOTE: m.code may be undefined ??, also merkmale_from_hdr may have duplicates... but that would should be deduplicated
function render_nw_block(merkmale_from_hdr, merkmale_from_vorsp, width, height) {
  return [(<th rowSpan={height} colSpan={width} key={'pvt-nw-block'} className="kopfvorspalte">
    {merkmale_from_hdr.flat().map((m) => <div key={`merkmal-from-hdr-${m.code || some_other_number++}`}>{Destatis.prettyprint_merkmal(m)}</div>)}
    {merkmale_from_vorsp.flat().map((m) => <div key={`merkmal-from-vorsp-${m.code || some_other_number++}`}>{Destatis.prettyprint_merkmal(m)}</div>)}
  </th>)];
}

// function makeDestatisRenderer2(opts = {}) {
export class DestatisTableRenderer2 extends React.PureComponent {
  render() {
    let { disableCache } = this.props;
    disableCache = !!disableCache;
    if (ERROR_LOG) { console.log('makeDestatisRenderer2::render() called with props:', this.props); }
    const cache_key = Destatis.build_cache_key_for_renderer(this.props);
    if (ERROR_LOG) { console.log(`tableRenderer2_cache has ${Object.keys(tableRenderer2_cache).length} entries.`); }
    // if data_html is sent for rendering, always overwrite cache
    if (this.props.data_html && this.props.data_html.data_html) {
      if (ERROR_LOG) { console.log('dangerouslySetInnerHTML:', this.props.data_html.data_html); }
      const cacheable_entry = <div dangerouslySetInnerHTML={{ __html: this.props.data_html.data_html }} />;
      // always overwrite cache
      if (!disableCache) {
        tableRenderer2_cache[cache_key] = cacheable_entry;
      }
      return cacheable_entry;
    }
    // if there is data_html set, then put data_html into cache and show immediately
    // then mark data_html as cleared, and rely on cache for next cycle
    if (cache_key in tableRenderer2_cache) {
      // nicht bei {"merkmale_length":0,"auspraegungenMap_length":0}
      if (ERROR_LOG) { console.log('tableRenderer2_cache answered from cache for cache_key:', cache_key); } //back in
      return tableRenderer2_cache[cache_key];
      //}
    }
    // TODO: remove debug putting fake timeslices into SEMST merkmale
    let canhaz_merkmale;
    const canhaz_isKeyFigure = () => this.props.isKeyFigure;
    // console.log('DISPLAY#-1', this.props.merkmale);
    const { isKeyFigure } = this.props;
    let canhaz_merkmale_nullable;
    if (isKeyFigure) {
      canhaz_merkmale = () => this.props.test || [];
      canhaz_merkmale_nullable = () => this.props.test;
    } else {
      canhaz_merkmale = () => this.props.merkmale || [];
      canhaz_merkmale_nullable = () => this.props.merkmale;
    }
    const auspraegungen_map = this.props.auspraegungenMap || {};
    const zeitscheiben_map = this.props.zeitscheibenMap || {};
    const einheiten_map = this.props.einheitenMap || {};
    const macodeMap = Destatis.build_macodeMap(canhaz_merkmale_nullable(), auspraegungen_map); // TODO: move macodeMap building out of here
    /** if you pass 1 argument, it is lifted to merkmal
     *  if you pass 2 arguments, they are lifted to auspraegung
     * @param {string} mcode_raw code for Merkmal withozut [brackets]
     * @param {string} acode_raw code for Auspraegung without [brackets]
     * @return {Merkmal|Auspraegung} object
     */
    function lift_code_to_merkmal_f(mcode_raw, acode_raw) {
      const code_bracketized = acode_raw ? Destatis.bracketize_macode(mcode_raw, acode_raw) : Destatis.bracketize_mcode(mcode_raw);
      return (macodeMap[code_bracketized] || []);
    }

    function get_auspraegungen_for_merkmal_code(mcode_raw) {
      return auspraegungen_map[mcode_raw]
        || zeitscheiben_map[mcode_raw]
        || einheiten_map[mcode_raw]
        || [SENTINEL_AUSPRAEGUNG]; // default element for empty enumerations
    }

    const val_graph = this.props.val_graph || [];
    const coltitle_graph = []; // the renderer actually supports titles in vorspalte, but there is not interface element to define them
    const col_graph = this.props.col_graph || [];
    const rowtitle_graph = this.props.title_graph || [];
    const row_graph = this.props.row_graph || [];
    const arrDisplayById = this.props.arrDisplayById || {};

    // build a tree containing Merkmale und Ausprägungen as requested
    const [subheading_yes, subheading_no] = [true, false]; // labeled arguments for next 4 lines
    const pretransformed_coltitle_ary = pretransform_merkmal_tree(coltitle_graph, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_yes, arrDisplayById);
    // console.log("pretransformed_coltitle_ary_", pretransformed_coltitle_ary);
    const pretransformed_col_ary = pretransform_merkmal_tree(col_graph, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_no, arrDisplayById);
    // console.log("pretransformed_col_ary_", pretransformed_col_ary);
    const pretransformed_rowtitle_ary = pretransform_merkmal_tree(rowtitle_graph, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_yes, arrDisplayById);
    // console.log("pretransformed_rowtitle_ary", pretransformed_rowtitle_ary);
    const pretransformed_row_ary = pretransform_merkmal_tree(row_graph, lift_code_to_merkmal_f, get_auspraegungen_for_merkmal_code, subheading_no, arrDisplayById);
    // console.log("pretransformed_row_ary", pretransformed_row_ary);
    // console.log('COLTITLE', pretransformed_coltitle_ary);
    // console.log('COL_ARY', pretransformed_col_ary);
    // console.log('rowtitle_ary', pretransformed_rowtitle_ary);
    // console.log('ROW_TITLE GRAPH', rowtitle_graph);
    // console.log('ROW_ARY', pretransformed_row_ary);

    function truncateChildren(ary) {
      const truncated_ary = ary;
      for (let i = 0; i < truncated_ary.length; i += 1) {
        truncated_ary[i].children = truncateChildren(truncated_ary[i].children);
        if (truncated_ary[i].children.length > 5) {
          truncated_ary[i].children = truncated_ary[i].children.slice(0, 6);
          truncated_ary[i].children[5].label = '...';
          truncated_ary[i].children[5].children = [];
        }
        // 2585 Summen stehen am Anfang/Ende
        let sumOnTop = false; // nocht nicht änderbar
        if (truncated_ary[i].sumTogether) {
          let sumLabel = { label: 'Zusammen', children: truncated_ary?.[i]?.children?.[0]?.children || [] };
          if (sumOnTop) {
            truncated_ary[i].children.unshift(sumLabel); // am Anfang
          } else {
            truncated_ary[i].children.push(sumLabel); // ans Ende
          }
        }
        if (truncated_ary[i].lastSumTotal) {
          let sumLabel = { label: 'Insgesamt', children: truncated_ary?.[i]?.children?.[0]?.children || [] };
          truncated_ary[i].children.push(sumLabel); // ans Ende
        }
        if (truncated_ary[i].firstSumTotal) {
          let sumLabel = { label: 'davon:', children: [] };
          truncated_ary[i].children.unshift(sumLabel); // am Anfang
           sumLabel = { label: 'Insgesamt', children: truncated_ary?.[i]?.children?.[1]?.children || [] };
          truncated_ary[i].children.unshift(sumLabel); // am Anfang
        }
      }
      return truncated_ary;
    }

    function truncateTitle(ary, titles) {
      if (titles[0]) {
      }
      const title_ary = ary;
      const title_graph = titles;
      let truncated_title_ary = [];
      if (title_graph.length > 0) {
        for (let i = 0; i < title_ary.length; i += 1) {
          title_ary[i].children = truncateTitle(title_ary[i].children, title_graph[0].children);
        }
      }
      if (title_ary.length > 5) {
        const truncated_ary = title_ary.slice(0, 6);
        truncated_ary[5].label = '...';
        truncated_ary[5].children = [];
        truncated_title_ary = truncated_ary;
      } else {
        truncated_title_ary = title_ary;
      }
      // 2585 Summen stehen am Anfang/Ende
      let sumOnTop = false; // nocht nicht änderbar
      if (title_graph.length > 0 && title_graph[0].sumTogether) {
        let sumLabel = { label: 'Zusammen', children: [] };
        if (truncated_title_ary.length > 0 && truncated_title_ary[0].children.length > 0) {
          sumLabel.children = [...truncated_title_ary[0].children];
        }
        if (sumOnTop) {
          truncated_title_ary.unshift(sumLabel); // am Anfang
        } else {
          truncated_title_ary.push(sumLabel); // ans Ende
        }
      }
      if (title_graph.length > 0 && title_graph[0].lastSumTotal) {
        let sumLabel = { label: 'Insgesamt', children: [] };
        if (truncated_title_ary.length > 0 && truncated_title_ary[0].children.length > 0) {
          sumLabel.children = [...truncated_title_ary[0].children];
        }
        truncated_title_ary.push(sumLabel); // ans Ende
      }
      if (title_graph.length > 0 && title_graph[0].firstSumTotal) {
        let sumLabel = { label: 'Insgesamt', children: [] };
        if (truncated_title_ary.length > 0 && truncated_title_ary[0].children.length > 0) {
          sumLabel.children = [...truncated_title_ary[0].children];
        }
        truncated_title_ary.unshift(sumLabel); // am Anfang
      }
      return truncated_title_ary;
    }

    const pretransformed_col_ary_truncated = truncateChildren(pretransformed_col_ary);
    const pretransformed_row_ary_truncated = truncateChildren(pretransformed_row_ary);
    // console.log("ROWTITLE:", pretransformed_rowtitle_ary);
    const pretransformed_rowtitle_ary_truncated = truncateTitle(pretransformed_rowtitle_ary, rowtitle_graph);
    // console.log("ROWTITLE2:", pretransformed_rowtitle_ary_truncated);
    // const pretransformed_col_ary_truncated_sum = includeSum(pretransformed_col_ary_truncated);
    // const pretransformed_row_ary_truncated_sum = includeSum(pretransformed_row_ary_truncated);

    // build header row (tabellenkopf, only column data) as sparse matrix of <td> contents
    const nheader_rows = get_tree_depth(pretransformed_col_ary_truncated); // number of rows in the header is equal to the number of hierarchy levels
    const nbody_rows = 0; // should be: = vorsp.length; // because it introduces a mutual recursive depenency beween render_header_row_stage2 and render_vorspalte_stage2, therefore we cannot calculate it in 1 pass; it's ok to use 0, because we don't have vertical subheadings in the table anyway
    const overall_row_span = nheader_rows + nbody_rows; // total number of rows (downwards): nheader_rows + nbody_rows (will be wrong, unless we do 2-pass for nbody_rows)
    const hdr = render_header_row_stage2(pretransformed_coltitle_ary, pretransformed_col_ary_truncated, overall_row_span);

    // build leading column (vorspalte) as matrix of <td> contents
    const nvorsp_cols = get_tree_depth(pretransformed_row_ary_truncated); // number of columns in left-hand-side vorspalte is equal to the number of hierarchy level
    const nbody_cols = (hdr[0] || []).length; // number of columns in the body is equal to the number of columns in header
    const overall_col_span = nvorsp_cols + nbody_cols; // total number of columns (sideways) is: nvorsp_cols + nbody_cols
    const vorsp = render_vorspalte_stage2(pretransformed_rowtitle_ary_truncated, pretransformed_row_ary_truncated, overall_col_span);

    // console.log(`makeDestatisRenderer2 hdr:`, hdr);
    // console.log(`makeDestatisRenderer2 vorsp:`, vorsp);

    if (ERROR_LOG) { console.log('makeDestatisRenderer2 data:', this.props.data); }

    const nwblock_width = nvorsp_cols;
    const nwblock_height = nheader_rows;

    // build vals-header
    // const debug_hdr        = <tr><th colSpan={overall_col_span} className="ueberschrift" key={`debug-hdr-${some_other_number++}`}>{`render count=${some_number++}`}</th></tr>;
    const caption_hdr = ''; //= <caption><span style={{color: '#FFFFEE'}}>{`render count=${some_number++}`}</span></caption>;
    const table_filter_hdr = <tr><th colSpan={overall_col_span} className="ueberschrift" key={`table-filter-hdr-${some_other_number++}`}>{Tree.flat(val_graph).map((n) => lift_code_to_merkmal_f(n.code)).map((m) => <div key={`table-filter-hdr-item-${some_other_number++}`}>{Destatis.prettyprint_merkmal(m)}</div>)}</th></tr>;

    // build nwblock (block in north-western edge of the table)
    const nwblock_merkmale_from_hdr = extract_nwblock_merkmale(coltitle_graph.concat(col_graph), lift_code_to_merkmal_f);
    const nwblock_merkmale_from_vorsp = extract_nwblock_merkmale(rowtitle_graph.concat(row_graph), lift_code_to_merkmal_f);
    if (ERROR_LOG) { console.log('renderer2 nwblock:', nwblock_merkmale_from_hdr, nwblock_merkmale_from_vorsp); }
    const nwblock = render_nw_block(nwblock_merkmale_from_hdr, nwblock_merkmale_from_vorsp, nwblock_width, nwblock_height);
    // insert nwblock into header matrix
    hdr[0] = nwblock.concat(hdr[0]);

    const thead = <thead>{table_filter_hdr}{hdr.map((row) => <tr key={`hdr-${some_other_number++}`}>{row}</tr>)}</thead>;
    const tbody = <tbody>{vorsp.map((row) => <tr key={`vorsp-${some_other_number++}`}>{row}</tr>)}</tbody>;

    const cacheable_entry = (<table id="ET">{caption_hdr}{thead}{tbody}</table>);
    tableRenderer2_cache[cache_key] = cacheable_entry;
    return cacheable_entry;
  }
}

/*
  DestatisTableRenderer2.defaultProps = PivotData.defaultProps;
  DestatisTableRenderer2.propTypes = PivotData.propTypes;
  DestatisTableRenderer2.defaultProps.tableColorScaleGenerator = redColorScaleGenerator;
  DestatisTableRenderer2.defaultProps.tableOptions = {};
  DestatisTableRenderer2.propTypes.tableColorScaleGenerator = PropTypes.func;
  DestatisTableRenderer2.propTypes.tableOptions = PropTypes.object;
  return DestatisTableRenderer2;
}

export default { // trace to PivotTable.props.renderers, PivotTableUI.props.renderers
  Destatis: makeDestatisRenderer2(),
  'Destatis Preview': makeDestatisRenderer(),
  'Destatis Heatmap': makeDestatisRenderer({heatmapMode: 'full'}),
  'Destatis Col Heatmap': makeDestatisRenderer({heatmapMode: 'col'}),
  'Destatis Row Heatmap': makeDestatisRenderer({heatmapMode: 'row'}),

  Table: makeRenderer(),
  'Table Heatmap': makeRenderer({heatmapMode: 'full'}),
  'Table Col Heatmap': makeRenderer({heatmapMode: 'col'}),
  'Table Row Heatmap': makeRenderer({heatmapMode: 'row'}),

  'Exportable TSV': TSVExportRenderer,
};
*/
